import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { CheckCircleOutline, RemoveCircleOutline, Search } from '@material-ui/icons';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { GREEN, TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import QRCodeScanIconCustom from '../CustomIcons/QRCodeScanIconCustom.jsx';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';
import Tag from '../Tag.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 80,
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  intercomRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowWithAction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: 'white',
  },
  button: {
    color: 'red',
    fontSize: 13,
    fontWeight: 'bold',
    textDecoration: 'underline',
    marginLeft: -5,
    width: 'max-content',
  },
  lockContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginLeft: -5,
  },
  groupContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '5px',
  },
  groupTag: {
    backgroundColor: '#e0e0e0',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '14px',
  },
  lockRowContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: 5
  },
});

@connect((state) => ({ viewLoading: state.utils.viewLoading, intercom: state.intercom, themeName: state.settings.items.theme.data.themeName }))
class VirtualIntercomTableView extends React.Component {
  render() {
    const {
      classes,
      viewLoading,
      themeName,
      intercom: { selectedIntercom, data: { content: intercomData, pagination: { number: currentPage, size, totalPages, totalElements }, filters }},
      onSelectVirtualIntercom,
      onRefreshVirtualIntercoms,
      onFetchVirtualIntercomsOnPage,
      onDownloadHyperTileQRCode
    } = this.props;
    const headerColor = getColorFromThemeName(themeName);
    const filtersActive = Boolean(filters && (filters.name || filters.groupId));
    return (
      <div className="list-view details-section" style={{ top: 190, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(intercomData) ? (
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={3}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}><Entity entity="virtualIntercoms" /></h3>
                        <IconButton onClick={() => onRefreshVirtualIntercoms()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="virtualIntercomsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchVirtualIntercomsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchVirtualIntercomsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}>ID</h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="virtualIntercomName" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="virtualIntercomStatus" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="virtualIntercomExtensionGroups" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="virtualIntercomSmartLocks" /></h4></TableCell>
                    <TableCell style={{ minWidth: 300 }}><h4 className={classes.tableColumnText}><Entity entity="virtualIntercomGeolocation" /></h4></TableCell>
                    <TableCell style={{ minWidth: 120 }}><h4 className={classes.tableColumnText}><Entity entity="qrCode" /></h4></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(intercomData, (intercom) => (
                    <TableRow
                      key={intercom.id}
                      className={classes.row}
                      hover
                      classes={{
                        selected: classes.rowSelected,
                        hover: classes.rowHovered,
                      }}
                      onClick={event => onSelectVirtualIntercom(intercom)}
                      selected={selectedIntercom && selectedIntercom.id === intercom.id}
                    >
                      <TableCell>
                        <div className={classes.intercomRowContainer}>
                          <h5 style={{ fontSize: 16 }}>{intercom.id}</h5>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.intercomRowContainer} style={{ flexDirection: 'column', alignItems: 'flex-start', marginTop: 10, marginBottom: 10 }}>
                          <h5 style={{ fontWeight: 'bold', fontSize: 16, margin: '0', marginBottom: 10 }}>{intercom.name}</h5>
                          <h5 style={{ fontSize: 16, margin: '0', fontWeight: 'light' }}>{intercom.hyperTile?.serialNumber}</h5>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.lockRowContainer}>
                          <h5 style={{ color: intercom.enabled ? GREEN : 'grey', marginRight: 10, fontWeight: 'bold' }}> <Entity key={intercom.enabled} entity={intercom.enabled ? 'virtualIntercomStatusEnabled' : 'virtualIntercomStatusDisabled'} /></h5>
                          {intercom.enabled ? (
                            <CheckCircleOutline style={{ fontSize: 20, color: GREEN,  }} />
                          ) : <RemoveCircleOutline style={{ fontSize: 20, color: 'grey' }} />}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.groupContainer}>
                          {_.map(_.sortBy(intercom.groups, 'id'), group => (
                            <span className="resourceInfoRow-typeTag-flat">
                              <h5 style={{ color: 'white', margin: 0 }}>{group.name}</h5>
                            </span>
                          ))}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.lockContainer}>
                          {_.map(_.sortBy(intercom.smartLocks, 'id'), lock => (
                            <Tag
                              key={lock.id}
                              tag={{type: 'lock', name: lock.name, color: '#ba68c8'}}
                              style={{ padding: 5 }}
                              textStyle={{ fontSize: 14 }}
                            />
                          ))}
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.lockRowContainer}>
                          <h5 style={{ fontWeight: 'bold', color: intercom.latitude && intercom.longitude && intercom.radiusMeters ? GREEN : 'grey', marginRight: 10 }}> <Entity key={intercom.latitude && intercom.longitude && intercom.radiusMeters} entity={intercom.latitude && intercom.longitude && intercom.radiusMeters ? 'virtualIntercomStatusEnabled' : 'virtualIntercomStatusDisabled'} /></h5>
                          {intercom.latitude && intercom.longitude && intercom.radiusMeters ? (
                            <CheckCircleOutline style={{ fontSize: 20, color: GREEN }} />
                          ) : <RemoveCircleOutline style={{ fontSize: 20, color: 'grey' }} />}
                        </div>
                      </TableCell>
                      <TableCell>
                        <>
                        {intercom.hyperTile?.serialNumber ? (
                          <IconButton
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              onDownloadHyperTileQRCode(intercom.hyperTile.serialNumber);
                            }}
                          >
                          <QRCodeScanIconCustom style={{ width: 23, color: '#3f3f3f' }} />
                          <Search style={{ position: 'absolute', bottom: 2, left: -2, color: '#3f3f3f', borderRadius: 10,fontSize: 20 }} />
                          </IconButton>
                        ) : (
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                            <h5 style={{ color: 'grey', fontSize: 16 }}>N/A</h5>
                          </div>
                        )}
                        </>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="virtualIntercomsTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchVirtualIntercomsOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchVirtualIntercomsOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
          ) : (
            <div>
              {!viewLoading ? (
                <EmptyView
                  title={!filtersActive ? 'noVirtualIntercoms' : 'noVirtualIntercomsFound'}
                  subtitle={!filtersActive ? 'noVirtualIntercomsDescription' : 'noVirtualIntercomsFoundDescription'}
                  onNewEntity={null}
                  newEntityTitle={null}
                />
              ) : (
                <ListLoadingView />
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(VirtualIntercomTableView); 